export default __webpack_public_path__ + "static/media/device-provision-orange.1dc010a3.svg";